import * as React from 'react'
import { Switch, Route, Redirect } from 'react-router'
import { useTranslation } from "react-i18next"
import { RouteComponentProps, matchPath } from 'react-router-dom'
import ScrollToTopOnMount from "../components/Effects/ScrollToTopOnMount"
import TopNavigation from "../components/Navigation/TopNavigation"
import TabItem from "../components/Navigation/TabItem"
import ERoute from "../ERoute"
import FullPageContent from '../components/Page/FullPageContent'
import TopSubnavigation from '../components/Navigation/TopSubnavigation'
import RouteHelper from '../helpers/RouteHelper'
import TimeTrackingOverview from './TimeTrackingOverview'
import TimeTrackingReport from './TimeTrackingReport'
import UserWorkspaceSettingHelper from '../helpers/UserWorkspaceSettingHelper'
import { UserWorkspaceSettingScope } from '../types'

type IProps = & RouteComponentProps<any>

const TimeTracking = (props: IProps) => {
  const { t } = useTranslation()
  const { history } = props
  const activePath = props.location.pathname

  const onNavigateItemClick = (path: string) => {
    history.replace(path)
  }

  return (
    <>
      <ScrollToTopOnMount />

      <TopNavigation
        icon='stopwatch'
        title={t('TimeTracking::Timesheets')}
      />

      <FullPageContent style={{ background: 'transparent' }}>
        <TopSubnavigation>
          <TabItem
            active={!!matchPath(activePath, { path: ERoute.PATH_TIMESHEETS_OVERVIEW, exact: true })}
            onClick={() => onNavigateItemClick(RouteHelper.process(ERoute.PATH_TIMESHEETS_OVERVIEW))}
          >
            {t('TimeTracking::Overview')}
          </TabItem>
          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.REPORTING) && <TabItem
            active={!!matchPath(activePath, { path: ERoute.PATH_TIMESHEETS_REPORTING, exact: true })}
            onClick={() => onNavigateItemClick(RouteHelper.process(ERoute.PATH_TIMESHEETS_REPORTING))}
          >
            {t('TimeTracking::Reporting')}
          </TabItem>}
        </TopSubnavigation>
        <Switch>
          <Route path={ERoute.PATH_TIMESHEETS_OVERVIEW} component={TimeTrackingOverview} />
          {UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.REPORTING) && <Route path={ERoute.PATH_TIMESHEETS_REPORTING} component={TimeTrackingReport} />}
          <Redirect from='/' to={ERoute.PATH_TIMESHEETS_OVERVIEW} />
        </Switch>
      </FullPageContent>
    </>
  )
}

export default TimeTracking